// Scroll behavior thresholds
export const SCROLL_THRESHOLD_DISABLE = 150; // Pixels from bottom to disable auto-scroll
export const SCROLL_THRESHOLD_ENABLE = 50;   // Pixels from bottom to re-enable auto-scroll

// Scroll near-bottom threshold
export const NEAR_BOTTOM_THRESHOLD = 100; // Pixels from bottom to consider "near bottom"

// Animation delays
export const ANIMATION_DELAY_200 = 'animation-delay-200';
export const ANIMATION_DELAY_400 = 'animation-delay-400';

// Copy notification timeout
export const COPY_NOTIFICATION_TIMEOUT = 2000; // Milliseconds to show copy success

// Search debounce delay
export const SEARCH_DEBOUNCE_DELAY = 300; // Milliseconds to wait before searching

// Scroll animation delays
export const SCROLL_ANIMATION_DELAY = 100; // Delay for scroll animations
export const SCROLL_RESET_DELAY = 50;      // Delay to reset auto-scrolling flag
export const SCROLL_IMMEDIATE = 0;         // No delay for immediate scrolling

// User scroll detection delay
export const USER_SCROLL_END_DELAY = 150; // Delay to detect when user stops scrolling

// Max textarea height
export const MAX_TEXTAREA_HEIGHT = 120; // Maximum height for input textarea
export const MIN_TEXTAREA_HEIGHT = 48;  // Minimum height for input textarea

// Message type constants
export const MESSAGE_TYPE_TOOL = 'tool';
export const MESSAGE_TYPE_THINKING = 'thinking';
export const SENDER_USER = 'user';
export const SENDER_SYSTEM = 'system';
export const SENDER_AGENT = 'agent';

// Agent types
export const AGENT_TYPES = {
  CODING: 'coding_agent',
  CODER: 'coder',
  INVESTIGATION: 'investigation-agent',
  BROWSER: 'browser-agent',
};

// Agent display configurations
export const AGENT_DISPLAY_CONFIG = {
  [AGENT_TYPES.CODING]: {
    icon: 'Code',
    text: 'Coding Agent',
    colorClass: 'text-accent-purple dark:text-accent-purpleLight'
  },
  [AGENT_TYPES.CODER]: {
    icon: 'Code',
    text: 'Coding Agent',
    colorClass: 'text-accent-purple dark:text-accent-purpleLight'
  },
  [AGENT_TYPES.INVESTIGATION]: {
    icon: 'Search',
    text: 'Investigation Agent',
    colorClass: 'text-accent-purple dark:text-accent-purpleLight'
  },
  [AGENT_TYPES.BROWSER]: {
    icon: 'Globe',
    text: 'Browser Agent',
    colorClass: 'text-accent-purple dark:text-accent-purpleLight'
  }
};

// Context usage alert levels
export const CONTEXT_ALERT_LEVELS = {
  CRITICAL: 'critical',
  WARNING: 'warning',
  INFO: 'info'
};

// Context usage thresholds
export const CONTEXT_WARNING_THRESHOLD = 60; // Percentage to show context warning

// Agent status
export const AGENT_STATUS = {
  GENERATING: 'generating',
  STOPPED: 'stopped'
};
